const STORAGE_KEY = "tutorify-lang";

export function getStoredLanguageCode(): string {
  const lang = localStorage.getItem(STORAGE_KEY);
  return lang === "ENGLISH" ? "en" : "de";
}

export function getStoredLanguageRaw(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

export function setStoredLanguage(lang: string): void {
  localStorage.setItem(STORAGE_KEY, lang);
}

export { STORAGE_KEY as LANGUAGE_STORAGE_KEY };
